export const EY_TEMPLATES = ["ey_resume_pptx"];
export const EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL = ["education", "qualifications"];
export const EY_CERTIFICATES_FIELD_NAMES_OTHER = [
  "accreditations",
  "certificates",
  "licenses_and_certifications",
  "ey_certificates",
  "prof_qualification",
  "memberships"
];
export const EY_CERTIFICATES_FIELD_NAMES = [
  ...EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL,
  ...EY_CERTIFICATES_FIELD_NAMES_OTHER
];
